module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-14.cc8621c0.svg";